import { render, staticRenderFns } from "./SiretPanel.vue?vue&type=template&id=79f2047e&scoped=true&"
import script from "./SiretPanel.vue?vue&type=script&lang=js&"
export * from "./SiretPanel.vue?vue&type=script&lang=js&"
import style0 from "./SiretPanel.vue?vue&type=style&index=0&id=79f2047e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2047e",
  null
  
)

export default component.exports